import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { isLiffMockEnabled, createLiffMock } from './mocks/liff.mock';

// **IMPORTANT**: Setup LIFF (real or mock) SYNCHRONOUSLY before mounting the app
// This must happen before AuthContext tries to initialize LIFF
const mockEnabled = isLiffMockEnabled();
console.log('[App Entry] LIFF Mock Mode:', mockEnabled ? 'ENABLED' : 'DISABLED');
console.log('[App Entry] REACT_APP_USE_LIFF_MOCK env:', process.env.REACT_APP_USE_LIFF_MOCK);

if (mockEnabled) {
  // Synchronously setup mock LIFF
  console.log('[App Entry] Setting up mock LIFF...');
  const liffMock = createLiffMock();
  (window as any).liff = liffMock;
  console.log('[App Entry] Mock LIFF setup complete:', (window as any).liff);
} else {
  console.log('[App Entry] Using real LIFF SDK');
}

// Mount the app
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
